import {
  useApi,
  configApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';

type CompanySlugResult = {
  companySlug: string | undefined;
  loading: boolean;
  error: Error | undefined;
};

/**
 * Resolves the current external user's company slug by calling the
 * billing-portal `access/guard` endpoint.
 */
export const useCompanySlug = (): CompanySlugResult => {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);

  const { value, loading, error } = useAsync(async () => {
    const baseUrl = configApi.getString('backend.baseUrl');
    const { token } = await identityApi.getCredentials();

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const res = await fetch(`${baseUrl}/api/billing-portal/access/guard`, {
      method: 'POST',
      headers,
      body: '{}',
    });

    if (!res.ok) {
      throw new Error(
        `Failed to resolve company: ${res.status} ${res.statusText}`,
      );
    }

    const data = await res.json();
    return (data?.companySlug as string) ?? undefined;
  }, []);

  return {
    companySlug: value ?? undefined,
    loading,
    error,
  };
};
